import React from "react";
import { img_url, unavailable } from "../../Requests";
import { useModalStore,useContentStore } from "../../store";
import "./Card.css";

function Card({ id, poster, title, date, rating }) {
const {setModalShow}=useModalStore()
const {setContent}=useContentStore()

  return (
    <div className="cards" onClick={() => {setModalShow(true); setContent(id); }}>
      <img
        className="poster"
        src={poster ? `${img_url}/${poster}` : unavailable}
      >
      </img>
      <b className="title">{title}</b>
      <span className="subtitle">
        {rating} / 10
        <span className="subtitle">{date}</span>
      </span>
      
    </div>
  );
}

export default Card;
